/**
 * @hidden
 */
const config = {
  version: '2.11.0',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts